import { PatientStatus } from '~/services/api/enums';
import { IGetUsersPatientsParams } from '~/services/api/users/types';

export const defaultParams: IGetUsersPatientsParams = {
  orderBy: 'ProgramId',
  statuses: [PatientStatus.Approved, PatientStatus.Active],
};

export default {};
